/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=74dcaa44&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=74dcaa44&lang=scss&scoped=true"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74dcaa44"]])

export default __exports__